var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlay = function SvgPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 16,
    height: 16,
    viewBox: "0 0 503.363 503.363",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M131.082 486.563c-34.8 24-63.2 14.4-63.2-28v-413.6c0-42.4 28.4-52 63.2-28l278.4 191.2c34.8 24 34.8 63.2 0 86.8z",
    style: {
      fill: "#54b265"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.082 503.363c-5.2 0-10.4-1.2-14.8-3.6-8.4-4.4-18.4-15.2-18.4-41.6v-413.2c0-26.4 10-37.2 18.4-41.6 13.2-6.8 31.2-3.2 50.8 10l278.4 191.2c18 12.4 28 28.8 28 46.8s-10 34.4-28 46.8l-278.4 191.2c-12.8 9.6-25.2 14-36 14m0-495.2q-6 0-10.8 2.4c-9.2 4.8-14.4 16.8-14.4 34.4v413.6c0 17.6 4.8 29.6 14.4 34.4 10.4 5.6 26 2 42.8-9.6l278.4-191.2c15.6-10.8 24.4-25.2 24.4-40 0-15.2-8.8-29.2-24.4-40l-278.4-191.2c-12-8.8-22.8-12.8-32-12.8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };